import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-header',
  template: `
    <div class="text-center">
      <span><h2>{{this.productLine}} Products</h2></span>
    </div>
  `,
  styles: [
    `
    h1 {
      font-weight: 400;
      color: #494A4C;
    }
    `
  ]
})
export class HeaderComponent {
  @Input() productLine: string;
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/header.component.ts